module.exports = __webpack_public_path__ + "static/media/arrows.b7da127a.svg";